var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from "class-transformer";
import { IsString, ValidateNested } from "class-validator";
export class EpicClientId {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], EpicClientId.prototype, "production", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], EpicClientId.prototype, "nonproduction", void 0);
export class EpicClientIds {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => EpicClientId),
    ValidateNested(),
    __metadata("design:type", EpicClientId)
], EpicClientIds.prototype, "patientAuthenticator", void 0);
__decorate([
    Type(() => EpicClientId),
    ValidateNested(),
    __metadata("design:type", EpicClientId)
], EpicClientIds.prototype, "providerAuthenticator", void 0);
__decorate([
    Type(() => EpicClientId),
    ValidateNested(),
    __metadata("design:type", EpicClientId)
], EpicClientIds.prototype, "patientDataConnector", void 0);
export var ConnectionValidationError;
(function (ConnectionValidationError) {
    ConnectionValidationError["FAILED_UNREACHABLE"] = "FAILED_UNREACHABLE";
    ConnectionValidationError["FAILED_AUTHENTICATION"] = "FAILED_AUTHENTICATION";
})(ConnectionValidationError || (ConnectionValidationError = {}));
